import axios, { InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';
import { AxiosError } from 'axios';
import { env } from '@/lib/env';

export const ssoInstance = axios.create({
  baseURL: env.NEXT_PUBLIC_SSO_API || 'https://oauth-service.staging-k8s.jubelio.com',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add the access token to requests
ssoInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const accessToken = Cookies.get('accessToken');

    if (accessToken) {
      config.headers.set('Authorization', `Bearer ${accessToken}`);
    }
    return config;
  },
  (error: AxiosError) => Promise.reject(error)
);
